import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getCoinBalance, getStakedLpBalance } from "../../libs/aptos_sdk";
import { getCoinInfo, CoinInfo } from "../../libs/pool";
import {
  get_coin_icon,
  get_coin_address_by_pair,
  get_lp_coin_balance,
} from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import Button from "../Common/Button";

interface FarmRowProps {
  pair: any;
}

const FarmRow: React.FC<FarmRowProps> = ({ pair }) => {
  const navigate = useNavigate();

  const [coinX, coinY] = get_coin_address_by_pair(pair.type);

  const coinInfoIconX = get_coin_icon(coinX);
  const coinInfoIconY = get_coin_icon(coinY);

  const [xCoinInfo, setXCoinInfo] = useState<CoinInfo | undefined>(undefined);
  const [yCoinInfo, setYCoinInfo] = useState<CoinInfo | undefined>(undefined);
  const [lpBalance, setLpBalance] = useState<number>(0);
  const [stakedLpBalance, setLpStakedBalance] = useState<number>(0);
  useEffect(() => {
    getCoinInfo(coinX).then((res) => {
      setXCoinInfo(res);
    });
  }, [coinX]);

  useEffect(() => {
    getCoinInfo(coinY).then((res) => {
      setYCoinInfo(res);
    });
  }, [coinY]);

  const accountAddress = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );

  useEffect(() => {
    const get = async () => {
      const x = await getCoinBalance(accountAddress, coinX);
      const y = await getCoinBalance(accountAddress, coinY);
      const lp_amount = await get_lp_coin_balance(accountAddress, coinX, coinY);
      const staked_lp_amount = await getStakedLpBalance(
        accountAddress,
        coinX,
        coinY
      );
      setLpBalance(Number(lp_amount));
      // @ts-ignore
      setWalletAmountX(Number(x));

      // @ts-ignore
      setWalletAmountY(Number(y));
      setLpStakedBalance(Number(staked_lp_amount));
    };

    if (accountAddress) {
      get();
    }
  }, [coinX, coinY, accountAddress]);

  return (
    <tr>
      <td>
        <div className="flex pl-2 pt-1 gap-3">
          <div className="flex justify-center items-center ">
            <img alt="Coin" className="w-10 h-10" src={coinInfoIconX.icon} />
            <img
              alt="Coin"
              className="w-10 h-10 -ml-4"
              src={coinInfoIconY.icon}
            />
          </div>
          <div className="flex justify-center items-center ">
            <p className="font-semibold">{xCoinInfo?.symbol!}</p>-
            <p className="font-semibold">{yCoinInfo?.symbol!}</p>
          </div>
        </div>
      </td>
      <td>
        <div className="flex justify-center items-center ">
          <p className="font-semibold">{lpBalance}</p>
        </div>
      </td>
      <td>
        <div className="flex justify-center items-center ">
          <p className="font-semibold">{stakedLpBalance}</p>
        </div>
      </td>
      <td className="p-2 flex justify-center">
        <div>
          <Button
            variant="gradient"
            className="w-32"
            onClick={() => navigate(`/farms/pair/${coinX}/${coinY}`)}
          >
            Manage
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default FarmRow;
